export { CardSmallImage } from './CardSmallImage';
export type { CardSmallImageProps } from './CardSmallImage';
